<template>
    <div>
      <textarea rows="rows" cols="cols"
                maxlength="maxlength"
                class="form-control"
                v-bind:readonly="readonly"
                :disabled="disabled"
                @input="updateValue($event.target.value)">{{ value }}</textarea>
        <span>{{diff}} caracter(es) restante(s).</span>
    </div>
</template>
<script>
    export default {
        props: {
            value: String,
            maxlength: {type: Number, default: 500, required: true},
            rows: {type: Number, default: 4},
            cols: {type: Number, default: 4},
            disabled: {
                type: Boolean,
                default: false
            },
            readonly: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            diff: function () {
                if (this.maxlength && this.value) {
                    return this.maxlength - this.value.length;
                }

                return this.maxlength
            }
        },
        methods: {
            updateValue(val) {
                this.$emit('input', val);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// DWTextarea.vue?79192d66